import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RBACService } from '../../shared/rbac.service';

@Component({
  selector: 'app-assets-importer',
  templateUrl: './assets-importer.component.html',
  styleUrls: ['./assets-importer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssetsImporterComponent implements OnInit {
  constructor(
    private rbac: RBACService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Importing creates assets, so this page needs the asset create permission. The nav button that
    // links here is already gated, but the route is reachable directly by URL, and without this guard
    // a user without create lands on a working importer that only fails at the final API call
    // (ImportsController gates the CSV analyse and import on registers-assets:create).
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_REGISTERS_ASSETS,
            RBACService.RBAC_A.A_CREATE
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage('You do not have permission to import assets.');
      this.router.navigate(['/asset-register']);
      return;
    }
  }
}
